<template>
  <AbsPopup id="driveList" title="구글 드라이브" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="body">
        <div class="path">
          <span>{{ path }}</span>
        </div>
        <li class="fileItem" @click="parent()">
          <icon size="xsmall" uicon="edit_arrow rotate180"/>
          <span>뒤로가기</span>
        </li>
        <li v-if="isLoading" class="loading">
          <div class="dot">
            <div></div><div></div><div></div><div></div><div></div>
          </div>
        </li>
        <li v-else v-for="item in list" :key="item.index" class="fileItem" @click="reload(item)">
          <icon v-if="item.mimeType === 'application/vnd.google-apps.folder'" size="xsmall" uicon="edit_open"/>
          <icon v-else-if="item.kind === 'drive#file'" size="xsmall" uicon="edit_writing"/>
          <span>{{ item.name }}</span>
        </li>
        <div>
          <UInput v-if="popuptype === 'save' || popuptype === 'epub'" type="text" placeholder="" v-model="filename">
            <span>{{ titlename }}</span>
          </UInput>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import {Base64} from '@/components/js/Utils.js'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    this.$gapi._libraryLoad('client').then(client => {
      this.$gapi.client = client
    })
    if (this.popuptype === 'save' || this.popuptype === 'epub') {
      if (this.option.param.file.filename) {
        this.filename = this.option.param.file.filename
      }
    }
    if (this.option.param.file && this.option.param.file.drive) {
      this.initfilename = this.option.param.file.filename
      this.fileid = this.option.param.file.fileid
      this.drive = this.option.param.file.drive
      var ar = this.option.param.file.parent.concat([])
      this.initfileparent = ar[ar.length - 1].id
      this.fileparent = ar[ar.length - 1].id
      var item = ar.pop()
      console.log(ar)
      this.parents = ar
      this.reload(item)
    } else {
      // this.$http.request({
      //   url: '/api/drive/drive',
      //   method: 'GET'
      // }).then((re) => {
      //   console.log(re)
      //   this.isLoading = false
      //   this.isLoading = false
      //   this.list = re.drives
      // })
      this.$gapi.request({
        path: 'https://www.googleapis.com/drive/v3/drives',
        method: 'GET',
        params: {}
      }).then(re => {
        console.log(re)
        if (re.error) {
          this.$store.dispatch('reLogIn')
        } else {
          this.isLoading = false
          this.list = re.result.drives
        }
      }).catch(this.relogin)
    }
    this.$emit('loading', false)
  },
  data () {
    return {
      drive: null,
      initfilename: '',
      fileid: '',
      filetype: 'upb',
      fileparent: '',
      initfileparent: '',
      filename: '',
      parents: [],
      list: [],
      isLoading: true
    }
  },
  name: 'DriveList',
  computed: {
    popuptype () {
      return this.option.param.type
    },
    titlename () {
      switch (this.popuptype) {
        case 'save' :
          return (this.fileid && this.initfilename === this.filename && this.fileparent === this.initfileparent) ? '업데이트 파일명' : '신규 파일명'
        case 'epub' :
          return (this.fileid && this.initfilename === this.filename && this.fileparent === this.initfileparent && this.filetype === 'epub') ? '업데이트 파일명' : '신규 파일명'
      }
    },
    returnParam () {
      var o = {}
      return o
    },
    path () {
      var st = ''
      if (this.drive) {
        st += '/' + this.drive.name
      }
      this.parents.forEach((n) => {
        st += '/' + n.name
      })
      switch (this.popuptype) {
        case 'save' :
          return st + '/' + this.filename + '.upb'
        case 'epub' :
          return st + '/' + this.filename + '.epub'
        default :
          return st
      }
    }
  },
  methods: {
    parent () {
      if (this.parents.length > 0) {
        this.parents.pop()
        var item = this.parents.pop()
        if (item) {
          this.reload(item)
        } else {
          this.reload(this.drive)
        }
      } else {
        this.drive = null
        this.isLoading = true
        this.list = []
        this.$gapi.request({
          path: 'https://www.googleapis.com/drive/v3/drives',
          method: 'GET',
          params: {}
        }).then(re => {
          console.log(re)
          if (re.error) {
            this.$store.dispatch('reLogIn')
          } else {
            this.isLoading = false
            this.list = re.result.drives
          }
        }).catch(this.relogin)
      }
    },
    reload (item) {
      console.log(item)
      if (item.kind === 'drive#file' && item.mimeType !== 'application/vnd.google-apps.folder') {
        switch (this.popuptype) {
          case 'save' :
          case 'epub' :
            this.initfilename = this.filename = item.name.split('.')[0]
            this.fileid = item.id
            this.filetype = item.name.split('.')[1]
            break
          default :
            this.isLoading = true
            // this.$http.request({
            //   url: '/api/drive/file',
            //   method: 'GET',
            //   params: {id: item.id}
            // }).then((re) => {
            //   console.log(re)
            //   var bytes = Base64.decode(re)
            //   this.$emit('submit', {
            //     id: item.id,
            //     name: item.name.split('.')[0],
            //     drive: this.drive,
            //     parent: this.parents,
            //     body: bytes
            //   })
            // })
            this.$gapi.request({
              path: 'https://www.googleapis.com/drive/v3/files/' + item.id,
              method: 'GET',
              params: {
                'supportsAllDrives': true,
                'alt': 'media',
                'fields': 'id, name'
              }
            }).then(re => {
              console.log(re)
              var bytes = Base64.decode(re.body)
              this.$emit('submit', {
                id: item.id,
                name: item.name.split('.')[0],
                drive: this.drive,
                parent: this.parents,
                body: bytes
              })
            }).catch(this.relogin)
            break
        }
      } else {
        this.isLoading = true
        this.list = []
        if (item.kind === 'drive#drive') {
          this.drive = item
        } else {
          this.parents.push(item)
          this.fileparent = item.id
        }
        var q = '"' + item.id + '" in parents'
        q += ' and trashed = false and (mimeType = "application/vnd.google-apps.folder"'
        if (this.popuptype !== 'epub') {
          q += ' or name contains ".upb")'
          // q += ' or mimeType = "application/upenbe")'
        } else {
          q += ' or mimeType = "application/epub+zip")'
        }
        // this.$http.request({
        //   url: '/api/drive/list',
        //   method: 'GET',
        //   params: {
        //     drive: this.drive.id,
        //     q: q
        //   }
        // }).then((re) => {
        //   console.log(re)
        //   this.list = re.files
        //   this.isLoading = false
        // })
        this.$gapi.request({
          path: 'https://www.googleapis.com/drive/v3/files/',
          method: 'GET',
          params: {
            'corpora': 'drive',
            'driveId': this.drive.id,
            'supportsAllDrives': true,
            'includeItemsFromAllDrives': true,
            'orderBy': 'folder,name',
            'q': q,
            'pageSize': 1000,
            'spaces': 'drive',
            'fields': 'kind, nextPageToken, files(kind, id, name, parents, mimeType)'
          }
        }).then(re => {
          console.log(re)
          this.list = re.result.files
          this.isLoading = false
        }).catch(this.relogin)
      }
    },
    cutString (st) {
      return (st.length > 10) ? st.substring(0, 20) + '...' : st
    },
    relogin () {
      this.$gapi.signIn().then((a) => {
        console.log('signIn', a)
      })
      // this.$store.dispatch('reLogIn')
      // switch (process.env.NODE_ENV) {
      //   case 'development' :
      //     window.open('/api/auth/driveGoogle?dev=true')
      //     break
      //   default :
      //     window.open('/api/auth/driveGoogle')
      //     break
      // }
    },
    submit () {
      console.log(this.$gapi)
      if (this.drive === null) {
      } else {
        var m, fn, f, p, isSingle, method, url
        switch (this.popuptype) {
          case 'save' :
            m = 'application/upenbe'
            fn = '.upb'
            f = new Blob([Base64.encode(JSON.stringify(this.option.param.body))], {type: m})
            isSingle = this.filename === this.initfilename && this.fileid
            break
          case 'epub' :
            m = 'application/epub+zip'
            fn = '.epub'
            f = this.option.param.body
            isSingle = (this.filetype === 'epub') && this.filename === this.initfilename && this.fileid
            break
        }
        p = {
          'name': this.filename + fn,
          'mimeType': m,
          'drive': this.drive.id
        }
        if (isSingle) {
          url = 'https://www.googleapis.com/upload/drive/v3/files/' + this.fileid
          method = 'patch'
        } else {
          url = 'https://www.googleapis.com/upload/drive/v3/files'
          method = 'post'
          p.parents = [this.parents[this.parents.length - 1].id]
        }
        if (this.list.find((n) => n.name === this.filename + fn && n.id !== this.fileid)) {
          this.alert('동일한 이름의 파일이 존재합니다.')
        } else {
          this.isLoading = true

          var form = new FormData()
          form.append('metadata', new Blob([JSON.stringify(p)], {type: 'application/json'}))
          form.append('file', f)
          console.log(p)
          this.$http.request({
            url: url,
            method: method,
            headers: { 'Authorization': 'Bearer ' + this.$gapi.client.getToken().access_token },
            params: {
              'uploadType': 'multipart',
              'supportsAllDrives': true,
              'fields': 'kind, id, name, parents, mimeType'
            },
            data: form
          }).then((re) => {
            console.log(re)
            // var bytes = Base64.decode(re.data)
            this.$emit('submit', {
              id: re.id,
              name: re.name.split('.')[0],
              drive: this.drive,
              parent: this.parents
            })
          }).catch(this.relogin)
          // this.$http.request({
          //   url: '/api/drive/save',
          //   method: 'POST',
          //   params: param,
          //   data: form
          // }).then((re) => {
          //   console.log(re)
          //   var bytes = Base64.decode(re.data)
          //   this.$emit('submit', {
          //     id: item.id,
          //     name: item.name.split('.')[0],
          //     drive: this.drive,
          //     parent: this.parents,
          //     body: bytes
          //   })
          // })
        }
      }
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#EpubInfo {
  padding: 10px 0;
  width: 600px;
}
.body {
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: 35px;
  padding: 0px;
  margin: 0px;
  min-height: 210px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}
.body .path {
  display: flex;
  text-align: left;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
  color: var(--text-title);
}
.body .fileItem {
  display: flex;
  list-style: none;
  text-align: left;
  border-color: var(--line-base);
  padding-left: 20px;
  align-items: center;
  cursor: pointer;
}
.body .fileItem span:first-child {
  margin-right: 5px;
}
.body .fileItem:hover {
  color: var(--bg-white);
  background-color: var(--icon-over);
}
.body li:nth-last-child(2) {
  margin-bottom: 10px;
}
.body .input {
  margin-top: auto;
  border-top: 1px solid var(--line-base);
}
.input > span {
  width: 130px;
  text-align: right;
  padding-right: 10px;
  margin-right: 10px;
  background-color: var(--disable);
}
.loading {
  list-style: none;
  padding: 25px 0;
}
.loading > div {
    position: relative;
    width: 96px;
    height: 96px;
    margin: 0 auto;
    padding: 10px;
}

.dot div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: translateY(-30px);
}

.dot div:nth-child(1) {
    width: 12px;
    height: 12px;
    border-radius: 10px;
    background-color: var(--text-base);
    animation: dot 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(2) {
    width: 10px;
    height: 10px;
    border-radius: 8px;
    background-color: var(--text-base);
    animation: dot 2s 0.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(3) {
    width: 8px;
    height: 8px;
    border-radius: 6px;
    background-color: var(--text-base);
    animation: dot 2s 0.2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(4) {
    width: 6px;
    height: 6px;
    border-radius: 4px;
    background-color: var(--text-base);
    animation: dot 2s 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(5) {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background-color: var(--text-base);
    animation: dot 2s 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

@keyframes dot {
    0% {
        transform: rotate(0deg) translateY(-30px);
    }
    100% {
        transform: rotate(360deg) translateY(-30px);
    }
}

.circle div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 76px;
    height: 76px;
    margin: auto;
    border: 10px solid #000;
    border-radius: 48px;
}

.circle div:before {
    position: absolute;
    right: -12px;
    top: -12px;
    width: 50px;
    height: 100px;
    background-color: #FFF;
    content: '';
    transform-origin: 0 50%;
    animation: circle 2s infinite;
}

.circle div:after {
    position: absolute;
    right: -12px;
    top: -12px;
    width: 50px;
    height: 100px;
    background-color: #FFF;
    content: '';
    transform-origin: 0 50%;
    animation: circle 2s 0.45s infinite;
}

@keyframes circle {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/popup/DriveList.vue